document.addEventListener('DOMContentLoaded', function() {
    const allCopyLinks = document.querySelectorAll('.copy-link');
    allCopyLinks.forEach(copyLink => {
        copyLink.addEventListener('click', (e) => {
            e.preventDefault();
            const thisLink = copyLink.getAttribute('data-link');
            navigator.clipboard.writeText(thisLink);
            alert("Link copied to clipboard");
        });
    });

    const allAccordionHeader = document.querySelectorAll('.more-details-accordion .accordion-heading');
    allAccordionHeader.forEach(accordionHeader => {
        accordionHeader.addEventListener('click', (e) => {
            e.preventDefault();
            const thisParent = accordionHeader.parentNode;
            if (thisParent.classList.contains('active')) {
                thisParent.classList.remove('active');
            } else {
                thisParent.classList.add('active');
            }
        });
    })
});